import React from 'react';
import {ReactComponent as Steel} from "./../../images/steel.svg";
import styles from './TakePart.module.scss'

const TakePart = () => {
    return (
        <div className={styles.contentContainer}>
            <Steel/>
            <a href={'https://project.rsv.ru/stal'} target='_blank' rel="noopener noreferrer"
               className={styles.takePartBtn}>УЧАСТВОВАТЬ</a>
        </div>
    )
};

export default TakePart;